import React, {useState, useEffect} from 'react';
import { useRouter } from 'next/router';
import ConsoHead from '../../components/header/ConsoHead';
import ShopNavbar from '../../components/header/ShopNavbar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Button from 'react-bootstrap/Button';
import ConsoFooter from '../../components/footer/ConsoSmallFooter';
import { useSelector, useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { isCartAvailable, saveProducts } from '../../components/cart/cartSlice';
import { updateProfileByRCA } from '../../components/login/userSlice';
import { accountMenuList, accountLogoffMenuList } from '../../components/header/mainMenuList';
import CartList from '../../components/cart/items/CartList';
import { loadCartFromStorage, saveCartToStorage, isCartProductExpired } from '../../components/utils/general/cartUtils';
import CartTotalPrice from '../../components/cart/items/CartTotalPrice';
import LoginBlock from '../../components/login/LoginBlock';
import SignupForm from '../../components/login/SignupForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUserCircle, faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import ErrorMessage from '../../components/elements/ErrorMessage';
import EmptyCart from '../../components/cart/items/EmptyCart';
import LoadingFullPage from '../../components/elements/LoadingFullPage';

const CartPage = () => {

    const dispatch = useDispatch();
    const router = useRouter();
    const user = useSelector(state => state.user);
    const shoppingCart = useSelector(state => state.cart);
    const cartStatus = shoppingCart.status;
    const cart = shoppingCart.products;
    
    const cookieState = useSelector( state => state.cookie);

    const [isCartError, editIsCartError] = useState(false);
    const [isError, editIsError] = useState(false);
    const [showLogin, editShowLogin] = useState(false);
    const [key, setKey] = useState('login');
    const [isCartReady, editIsCartReady] = useState(false);
    const [checkingCart, editCheckingCart] = useState(false);
    

    useEffect( ()=>{
            setupCart();
        }, []
    )

    //check availability
    useEffect( ()=>{
        if (isCartReady && user.isLoggedIn) {
            cartAvailability();
        }
    }, [isCartReady, user.isLoggedIn]
    )

    //cart checked, move to next step
    useEffect( ()=>{
        if (cartStatus == 'checked') {
            if (isCartValid()) {  
                router.push('/cart/livrare');
            } else {
                editCheckingCart(false);
                editIsCartError('Elimină produsele expirate.');
            }
        }
    }, [cartStatus])

    //auth expires
    useEffect( ()=>{
        if (user.status == 'loggedin' && cartStatus=='init') {
            editShowLogin(false);
        }
    }, [user.status])

    const seo  = {
        title: "Coș de cumpărături",
        description: "Coș de cumpărături - lista produselor adăugate în coș.",
        canonical: process.env.NEXT_PUBLIC_SITE_URL + '/cart'
    };

    const saveCartOnDevice  = () =>{
        if (cookieState.categories.personal == 1 ) {
            saveCartToStorage(shoppingCart);
        }
    }

    const setupCart = () => {
        if (cart && cart.length == 0) {
            const storageData = loadCartFromStorage();
            if (storageData && storageData.products) {
                dispatch(saveProducts({ products: storageData.products, status: 'init'}));
            }
        }
    }

    const removeCartItem = (product) =>{
        let newCartProducts = cart.filter( cart => cart.identificator_oferta != product.identificator_oferta);
        let newCart = Object.assign({},shoppingCart);
        window.Cart = newCart;
        newCart.products = newCartProducts
        if (cookieState.categories.personal == 1) {
            saveCartToStorage(newCart);
        }
        dispatch(saveProducts({
            products: newCartProducts,
            status: 'save',
        }));
        
    }

    const isCartValid = () => {
        let result = cart.find( product => product.isAvailable == false);
        return  result ? false : true;
    }

    const updateUserProfile = () =>{
        const rca = cart.find(prod => prod.type == 'rca');
        if (rca && !user.firstName && !user.lastName) {

            let userData = {
                firstName: rca.vehicle.owner.Prenume,
                lastName: rca.vehicle.owner.Nume,
                tipClient: rca.vehicle.owner.tipClient,
            };
            if (rca.vehicle.owner.tipClient == 'pf') {
                if (!user.CNP) userData.CNP = rca.vehicle.owner.CNP;
                if (!user.phone) userData.phone = rca.vehicle.owner.Telefon;
                if (!user.city) userData.city = rca.vehicle.address.Localitate.name;
                if (!user.county) userData.county = rca.vehicle.address.Judet.name;
            }

            dispatch(updateProfileByRCA({...userData}));
        }
        
    }

    const goToNextStep = async (e) => {
        e.preventDefault();
        editIsError(false);
        if (isCartValid()) {
            if (user.isLoggedIn) {
                await cartAvailability();
            } else {
                editShowLogin(true);
                editIsCartReady(true);
            }
        } else {
            editIsCartError('Elimină produsele expirate din coș.')
        }
    }

    const changeActiveTab = (e) => { setKey(e);}
    const closeLogin = () => {editShowLogin(false)}

    const cartAvailability = async () => {
        editCheckingCart(true);
        const products = cart.map(item => {
            let data;
            switch(item.type) {
                case 'rca':
                    data = {
                        type: item.type,
                        id: item.id,
                        identificator_oferta: item.identificator_oferta,
                    };
                    break;
                default:
                    break;
            }
            return data;
        });

        if (products.length> 0) {
            try {
                const resultAction = await dispatch(isCartAvailable({
                    products: products
                }));

                const response = unwrapResult(resultAction);
                if (!response.status) {
                    editCheckingCart(false);
                    if (response.hasOwnProperty('error') && response.error=='login') {
                        editShowLogin(true);
                    } else {
                        editIsError('Ups, ceva nu funcționează corect. Mai încearcă o dată.');
                    }
                   
                } else {
                    
                    updateUserProfile(products);
                    saveCartOnDevice();
                }

            } catch (err) {
             
                editIsError('Ups, ceva nu funcționează corect. Mai încearcă o dată.');
                editCheckingCart(false);
            }

        } 
    }

    const tabs = 
        <Row className="justify-content-center pt-5 g-0">
            <Col xs="12" sm="8" lg="8" >
                <Tabs activeKey={key}  onSelect={changeActiveTab}>
                    <Tab eventKey="login" title="Login" tabClassName="w-50 text-center"></Tab>
                    <Tab eventKey="signup" title="Creeaza cont" tabClassName="w-50 text-center"></Tab>
                </Tabs> 
            </Col>
        </Row>;

    const userConnect = key == "login" ? 
        <Row className="justify-content-center bg-home m-0">
            <LoginBlock xs="12" sm="8" lg="8" redirectUrl={false} openAccountLink={false}  />
        </Row>
        : 
        <Row className="justify-content-center bg-home py-0 m-0">
            <Col xs="12" sm="8" lg="8" className="bg-white p-5 pb-3">
                <h2 className="heading2 black-text text-center">Creeaza un cont nou</h2>
                <p className="text-center red">
                    <FontAwesomeIcon icon={faUserCircle} height={60} width={60} size="5x"/></p>
                <SignupForm redirectUrl={false} loginLink={false} />
            </Col>
        </Row>;

    const clearError = () => {editIsError(false);}
    
    const errorFlow = isError &&
        <Row xs={12} lg={8} className="mx-auto py-3">
            <Col xs={12}>
                <ErrorMessage title="Eroare" message={isError} />
                <Button className="mt-3" onClick={clearError}>
                    Închide
                </Button>
            </Col>
        </Row>;


    return (
        <>
            <ConsoHead seo={seo} />
            <ShopNavbar
                menu={user.isLoggedIn ? accountMenuList : accountLogoffMenuList}
                selected=""
                cart={cart}
            />
            <div className="mb-0 pb-0 bg-home" id="main" >
                {cart.length > 0 ? 
                <Container className="h-100">
                    {checkingCart &&
                        <Row xs={12} lg={8} className=" h-100">
                            <LoadingFullPage message="Te rugăm să aștepți" />
                        </Row>
                    }
                    {showLogin ?
                     <>
                        {tabs}
                        {userConnect}
                        <div className="py-3 text-center">
                            <Button variant="link" onClick={closeLogin}>
                                <FontAwesomeIcon icon={faShoppingCart} height="16" width="16" className="me-2 red"/>
                                Vezi coșul de cumpărături
                            </Button>
                        </div>
                    </>
                    :
                    <>
                        {isError ?
                        errorFlow
                        :
                        <Row xs={12} lg={8} className="mx-auto">
                            <Col  xs={12} lg={8} className="mx-auto text-center">       
                                <h1 className="heading2 pt-3 font-weight-bold black-text pb-0">
                                    Coșul meu
                                </h1>
                            </Col>
                            <CartList
                                cart={cart}
                                removeCartItem={removeCartItem}
                            />
                            <CartTotalPrice 
                                cart={cart} 
                                goToNextStep={goToNextStep} 
                                isError={isCartError}
                            />
                           
                        </Row>
                        }
                    </>
                    }
                </Container>
                :
                <EmptyCart />
                }
            </div>   
            <ConsoFooter />
        </>
    )
}

export default CartPage;

